import { Box, Stack } from "@mui/material"

import type { EntryWithVote } from "../../../../api/hooks/vote"
import { VoteCard } from "../listing/card"
import { UnregisteredUserPrompt, useUnregisteredUserPrompt } from "../warnings"
import { Description } from "./description"

interface PromotedEntryProps {
	promotion: EntryWithVote
	slug: string
}

export const PromotedEntry = ({ promotion, slug }: PromotedEntryProps) => {
	const {
		user: { userName, userImage },
	} = promotion
	const { isOpen, onUserAction, onClose } = useUnregisteredUserPrompt()

	return (
		<Box
			bgcolor='paper.secondary'
			mx={{ xs: -3, md: -5 }}
			px={3}
			py={9}
			mb={9}
			component='section'
		>
			<Stack
				maxWidth={{ lg: "979px", xs: "492px" }}
				margin='auto'
				direction={{ lg: "row", xs: "column" }}
				justifyContent='space-between'
				alignItems='center'
			>
				<Description name={userName} avatar={userImage || ""} />
				<Box width='100%' maxWidth='339px' margin='auto'>
					<VoteCard entry={promotion} onUserAction={onUserAction} />
					<UnregisteredUserPrompt
						isOpen={isOpen}
						onClose={onClose}
						slug={slug}
					/>
				</Box>
			</Stack>
		</Box>
	)
}
